<div  v-if="shouldRenderConfig" v-show="!getMatrixComplete" 
    v-bind:class="getClassName">
    <appPageOptionContainer></appPageOptionContainer>
    <appPageOptionAllAttributesContainer></appPageOptionAllAttributesContainer>
</div>